import { z } from 'zod';

export function normalizeRuPhone(raw: string): string {
    const onlyDigits = raw.replace(/\D/g, '');

    let d = onlyDigits;

    if (d.length === 11 && d.startsWith('8')) d = `7${d.slice(1)}`;
    else if (d.length === 10) d = `7${d}`;

    if (d.length !== 11 || !d.startsWith('7')) {
        throw new Error('Введите номер российского формата, напр.: +7 912 345-67-89');
    }

    return `+${d}`;
}

export const createOrderFromDraftSchema = z
    .object({
        draftId: z.string().uuid(),

        addressId: z.string().uuid().optional(),
        city: z.string().min(1, 'Это поле обязательно для заполнения').optional(),
        address: z.string().min(3, 'Это поле обязательно для заполнения').optional(),

        fullName: z.string().min(3, 'Введите ФИО полностью'),
        email: z
            .string({ required_error: 'Это поле обязательно для заполнения' })
            .min(3, 'Это поле обязательно для заполнения')
            .email('Неверный формат почты'),
        phone: z
            .union([
                z
                    .string()
                    .regex(/^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/, {
                        message: 'Неверный формат телефона',
                    }),
                z.literal(''),
            ])
            .optional()
            .transform(v => (v === '' ? undefined : v))
            .transform(v => {
                if (!v) return undefined;
                return normalizeRuPhone(v);
            }),
    })
    .superRefine((data, ctx) => {
        const hasId = !!data.addressId;
        const hasInline = !!data.city && !!data.address;
        if (!hasId && !hasInline) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Укажите адрес: выберите сохранённый или введите город и адрес',
                path: ['address'],
            });
        }

        if (!data.email && !data.phone) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Укажите e-mail или телефон',
                path: ['email'],
            });
        }
    });

export type CreateOrderFromDraftSchema = z.infer<typeof createOrderFromDraftSchema>;
